export default __webpack_public_path__ + "static/Banner-Suite-2-862db5c9991dd85f383032c25703eb8b.jpg";